.processing {
  color: var(--gray-500);
}

.active {
  font-weight: var(--font-weight-regular);
  color: var(--dropdown-item-color-selected);
}

.indicator {
  svg {
    top: calc(50% + 1px);
    width: 1rem;
    height: 1rem;
  }

  &[aria-disabled="true"] {
    color: var(--on-background);
  }
}
